package com.cybergstudios.rtc.engine

import com.cybergstudios.rtc.ai.AgentOpponent
import com.cybergstudios.rtc.levels.Level
import com.cybergstudios.rtc.world.Ball
import com.cybergstudios.rtc.world.Grid
import com.cybergstudios.rtc.world.Paddle

data class GameState(
    val context: Context,
    val canvasDimension: CanvasDimension,
    var mode: GameStateMode,
    var playerLives: Int,
    var playerPoints: Int,
    var opponentLives: Int,
    var level: Level,
    var paddlePlayer: Paddle,
    var paddleOpponent: Paddle,
    var agentOpponent: AgentOpponent,
    var ball: Ball,
    var tick: Double,
) {

    var grid: Grid = level.build()

    fun decreasePlayerLife() {
        if (playerLives > 0) {
            playerLives -= 1
            updateShipsMenu()
        }
        if (playerLives <= 0) {
            mode = GameStateMode.LOST
        }
    }

    fun decreaseOpponentLife() {
        if (opponentLives > 0) {
            opponentLives -= 1
        }
        if (opponentLives <= 0) {
            mode = GameStateMode.WON
        }
    }

    private fun updateShipsMenu() {
        context.renderShipsMenu(playerLives)
    }

    fun processOpponent() {
        agentOpponent.processOpponentMove(this)
    }

    fun polygonHit(points: Int) {
        playerPoints += points
        context.renderPlayerScore(playerPoints)

        if (grid.isCleared()) {
            mode = GameStateMode.WON
        }
    }

    fun applyNextLevel(nextLevel: Level) {
        level = nextLevel
        grid = level.build()
        paddlePlayer = Paddle.newPaddlePlayer()
        paddleOpponent = Paddle.newPaddleOpponent()
        ball = Ball()
        mode = GameStateMode.PLAYING
    }

    fun setThePlayerAsTheWinnerOfTheGame() {
        mode = GameStateMode.WON_GAME
    }
}

enum class GameStateMode {
    PLAYING,
    WON,
    WON_GAME,
    LOST,
}
